export default {
  state: {
    reload: 0, //刷新
    gametitle: '',
    proj: 1, // 遊戲项目类别
    chgbaco: 0, // 盤口
    dobuecode: 0,
    donotcode: null,
    oddItemSelect: { option: null, proj: null }, //游戏选单
    siteSelect: '',
    default_chodd: 0.005, // 修改倍率值
    setloading: false, // 修改動作時 遮罩狀態
    modal_show: false,
    moddata: [],
    topbardata: {},
    BettingStatus: '0',
    title: null,
    tema: 1,
    isdoubleOdds: '0',
    targetModeValue: false,
    targetData: []
  },
  actions: {
    upDate_reload ({ commit }, value) {
      commit('upDateReload', value)
    },
    chg_liveshow_state ({ commit }, value) {
      commit('liveshowState', value)
    },
    setTopBarData ({ commit,}, value) {
      commit('TopBarData', value.topbardata)
      commit('BettingStatus', value.RouteModule)
    },
    changeloading ({ commit }, value) {
      commit('liveshowLoading', value)
    },
    setPm1limit ({ commit }, value) {
      commit('changePm1limit', value)
    },
    upDate_oddItemSelect ({ commit }, value) {
      commit('upDateOddItemSelect', value)
    },
    upDate_isdoubleOdds({ commit }, value) {
      commit('upDateIsDoubleOdds', value)
    },
  },
  mutations: {
    upDateReload (state, value) {
      state.reload = Number(state.reload) + 1
    },
    liveshowState (state, value) {
      Object.keys(value).forEach(it => {
        state[it] = value[it]
      })
    },
    liveshowLoading(state, value) {
      state.setloading = value
    },
    TopBarData (state, value) {
      state.topbardata = value
    },
    BettingStatus (state, value) {
      const name = value.name.split('-')[0]
      const topbardata = state.topbardata
      const siteSelect = state.siteSelect
      if (name == 'liveshow') {
        state.BettingStatus = topbardata.perstate
      } else {
        let siteAry = siteSelect.split(',')

        if (topbardata.periodstate && (siteAry.length > 1 || siteAry.includes('0'))) {
          state.BettingStatus = topbardata.periodstate.every(it => it.perstate == '0') ? '0' : '1'
        } else {
          const status = topbardata.periodstate.filter(it => it.stid == siteSelect)
          state.BettingStatus = status[0].perstate
        }
      }
    },
    changePm1limit(state, value) {
      state.topbardata.pm1limit = value
    },
    upDateOddItemSelect (state, item) {
      state.oddItemSelect.option = item.option
      state.oddItemSelect.proj = item.proj || null
    },
    upDateIsDoubleOdds(state, value) {
      state.isdoubleOdds = value
    },
    upTargetModeValue(state, value) {
      state.targetModeValue = value
    },
    upTargetData (state, value) {
      if (value) {
        state.targetData.push(value)
        state.targetData.sort((a, b) => {
          return a - b
        })
      }
      else state.targetData = []

      state.targetData = Array.from(new Set(state.targetData))
    },
    deleteTargetData (state, value) {
      state.targetData = state.targetData.filter(it => it != value)
    },
  },
  getters: {
    getliveshow: state => state,
    getBettingStatus: state => state.BettingStatus,
  }
}